import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0); // ページのトップにスクロール
  }, [pathname]); // ページが変わるたびにスクロール位置をリセット

  return null; // レンダリングする内容はないためnullを返す
};

export default ScrollToTop;
